import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Unveil } from '@homeaway/react-unveil';
import AsyncRecentTravelerActivity from './AsyncRecentTravelerActivity';

class ConnectedRecentTravelerActivity extends Component {
  render() {
    const {
      isMobile,
      isTouchDevice,
      title,
      siteName
    } = this.props;

    return (
      <Unveil>
        <AsyncRecentTravelerActivity {...{ isMobile, isTouchDevice, title, siteName }} />
      </Unveil>
    );
  }
}

const mapStateToProps = ({
  system: { isMobile, isTouchDevice, siteName },
  content: { recentTravelerActivity: { recentPropertiesTitle: title } = {}}
}) => ({
  isMobile,
  isTouchDevice,
  title,
  siteName
});

export default connect(mapStateToProps)(ConnectedRecentTravelerActivity);
